<template>
<div class="chapter">
<div class="inner_page">
<p class="image" id="map"><a id="pXVIII"></a><img alt="Stephanie" src="images/map.jpg"/></p>
<p class="caption">Map of the Western Front, August 1914</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?79902f22